import * as z from 'zod';

import { supportPrioritySchema, supportStatusSchema } from './support-query-schema';

// Support ticket filter form schema
export const supportTicketFilterSchema = z.object({
  status: z
    .array(
      z.object({
        value: supportStatusSchema,
        label: z.string(),
      })
    )
    .optional(),
  priority: z
    .array(
      z.object({
        value: supportPrioritySchema,
        label: z.string(),
      })
    )
    .optional(),
  search: z.string().optional(),
});

// Support ticket properties form schema (for editing)
export const supportTicketPropertiesFormSchema = z.object({
  tags: z.array(z.string()),
  type: z.string(),
  status: supportStatusSchema,
  priority: supportPrioritySchema,
  group_id: z.number().nullable(),
  responder_id: z.number().nullable(),
});

// Support ticket create form schema
export const supportTicketCreateFormSchema = z.object({
  subject: z.string().min(1, 'Subject is required'),
  description: z.string().min(1, 'Description is required'),
  priority: supportPrioritySchema,
  type: z.string().prefault('Incident'),
  requester_id: z.number(),
  company_id: z.number().optional(),
  group_id: z.number().optional(),
  responder_id: z.number().optional(),
  tags: z.array(z.string()).prefault([]),
  custom_fields: z.record(z.string(), z.unknown()).optional(),
});

// Support ticket update form schema
export const supportTicketUpdateFormSchema = supportTicketCreateFormSchema.partial().extend({
  id: z.number(),
});

// Export types
export type SupportTicketFilter = z.infer<typeof supportTicketFilterSchema>;
export type SupportTicketPropertiesForm = z.infer<typeof supportTicketPropertiesFormSchema>;
export type SupportTicketCreateForm = z.infer<typeof supportTicketCreateFormSchema>;
export type SupportTicketUpdateForm = z.infer<typeof supportTicketUpdateFormSchema>;
